import { useCurrentDate } from 'hooks/date-hook';
import { useHttpClient } from 'hooks/http-hook';
import moment from 'moment';
import { useAuth } from "providers/AuthProvider";
import { useSnackbar } from "providers/SnackbarProvider";
import { useEffect, useState } from 'react';
import { calculateHoursFromTotalMinutes, calculateRemainingMinutesFromTotalMinutes, calculateTotalMinutes } from "utils";

const useHomeQuickModal = ({ onClose }) => {
  const showSnackbar = useSnackbar();
  const currentDate = useCurrentDate();
  const currentDateString = moment(currentDate).format('YYYY-MM-DD').toString();
  const { token } = useAuth();
  const { sendRequest } = useHttpClient();
  const [today, setToday] = useState(null);
  const initialQuickModalDetails = {
    dietNotes: '',
    exerciseHours: '',
    exerciseMinutes: '',
    exerciseNotes: '',
    meditation: '',
  }
  const [quickModalDetails, setQuickModalDetails] = useState(initialQuickModalDetails);

  useEffect(() => {
    const fetchToday = async () => {
      try {
        const response = await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/${currentDateString}`, 'GET', null, { Authorization: `Bearer ${token}` });
        const day = response.day;
        setToday(day);
        const fetchedDetails = {
          dietNotes: day.dietNotes,
          exerciseHours: day.exerciseMinutes !== null ? calculateHoursFromTotalMinutes(day.exerciseMinutes) : '',
          exerciseMinutes: day.exerciseMinutes !== null ? calculateRemainingMinutesFromTotalMinutes(day.exerciseMinutes) : '',
          exerciseNotes: day.exerciseNotes,
          meditation: day.meditation,
        }
        setQuickModalDetails(fetchedDetails);
      } catch (err) {
        console.error('error', err);
      }
    };
    fetchToday();
  }, [sendRequest, currentDateString, token]);

  const buildFormData = () => {
    const formData = new FormData();
    formData.append('date', currentDate);
    formData.append('dietNotes', quickModalDetails.dietNotes);
    formData.append('exerciseMinutes', calculateTotalMinutes(quickModalDetails.exerciseHours, quickModalDetails.exerciseMinutes));
    formData.append('exerciseNotes', quickModalDetails.exerciseNotes);
    formData.append('meditation', quickModalDetails.meditation);
    return formData;
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      if (!today) {
        showSnackbar('Day not created.');
        return;
      }
      const formData = buildFormData();
      await sendRequest(`${process.env.REACT_APP_BACKEND_URL}/days/${today.id}`, "PATCH", formData, { Authorization: "Bearer " + token });
      showSnackbar('Day updated.');
      onClose();
    } catch (err) {
      console.error(err);
      showSnackbar('Error saving.');
    }
  };
  
  return {
    quickModalDetails,
    setQuickModalDetails,
    submit,
  };
};

export default useHomeQuickModal;